import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { cn } from '@/lib/utils';
import { useScrollToTop } from '@/hooks/useScrollToTop';

const Navigation: React.FC = () => {
  const location = useLocation();
  const { user, signOut } = useAuth();
  const isPublicRoute = !location.pathname.startsWith('/app');
  const navigate = useNavigate();
  const scrollToTop = useScrollToTop();

  const handleNavigation = (href: string) => {
    // For same page navigation, just scroll to top
    if (location.pathname === href) {
      scrollToTop();
      return;
    }
    
    // For different pages, navigate and scroll to top
    navigate(href);
    // Use setTimeout to ensure navigation completes before scrolling
    setTimeout(() => {
      scrollToTop();
    }, 100);
  };

  if (!isPublicRoute) return null; // Don't show public nav in app

  return (
    <nav className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center space-x-2">
          <div className="flex items-center space-x-2">
            <img src="/StrtupStreak-Icon.png" alt="StartupStreak logo" className="h-9 w-9" />
            <span className="text-xl font-bold bg-gradient-primary bg-clip-text text-black">
            StartupStreak
            </span>
          </div>
        </Link>

        <div className="hidden md:flex items-center space-x-6">
          <button onClick={() => handleNavigation('/')} className="nav-link">Home</button>
          <button onClick={() => handleNavigation('/features')} className="nav-link">Features</button>
          <button onClick={() => handleNavigation('/pricing')} className="nav-link">Pricing</button>
          <button onClick={() => handleNavigation('/about')} className="nav-link">About</button>
          <button onClick={() => handleNavigation('/contact')} className="nav-link">Contact</button>
        </div>

        <div className="flex items-center space-x-4">
          {user ? (
            <div className="flex items-center space-x-4">
              <Link to="/app">
                <Button variant="outline">Dashboard</Button>
              </Link>
              <Button variant="ghost" onClick={signOut}>Sign Out</Button>
            </div>
          ) : (
            <div className="flex items-center space-x-4">
              <Link to="/login">
                <Button variant="ghost">Login</Button>
              </Link>
              <Link to="/signup">
                <Button className="btn-primary">Start Your Sprint</Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;